<template lang="html">
  <div class="automatic-recharge">
    <a
      href="#"
      class="btn btn-primary"
      @click.prevent="openAutomaticRechargeModal">Ativar Recarga Automática</a>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="automaticRechargeRequest"
      ref="automaticRechargeRequest"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ativar Recarga Automática</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeAutomaticRechargeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div
              v-if="error"
              class="alert alert-danger"
              role="alert">
              <span v-html="error.message" />
            </div>
            <form
              ref="chargeForm"
              class="charge-form">
              <div class="form-group">
                <h5>Informe um <b>valor mínimo</b> para a recarga automática</h5>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 automaticRechargeAmount">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <label class="input-group-text">R$</label>
                    </span>
                    <input
                      class="form-control automaticRechargeMinimumAmountInput"
                      ref="automaticRechargeMinimumAmount"
                      type="number"
                      min="5"
                      max="50000"
                      step="1"
                      v-model.number="automaticRechargeMinimumAmount"
                      @keydown.enter="generateAutomaticRecharge"
                      required>
                    <span class="input-group-append">
                      <label class="input-group-text">,00</label>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <h5>Informe o <b>valor</b> que deseja recarregar</h5>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 automaticRechargeAmount">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <label class="input-group-text">R$</label>
                    </span>
                    <input
                      class="form-control automaticRechargeAmountInput"
                      ref="automaticRechargeAmount"
                      type="number"
                      min="20"
                      max="50000"
                      step="1"
                      v-model.number="automaticRechargeAmount"
                      @keydown.enter="generateAutomaticRecharge"
                      required>
                    <span class="input-group-append">
                      <label class="input-group-text">,00</label>
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <div class="form-group">
                  <h3>Ou selecione o <b>desconto</b> deseja receber</h3>
                </div>
                <div class="form-group row">
                  <div :class="`col automaticRechargeSlider`">
                    <div
                      class="range-slider"
                      @click.prevent="sliderClick">
                      <input
                        class="form-control"
                        id="automaticRechargeSlider"
                        type="input"
                        data-slider-tooltip="hide"
                        :data-slider-ticks-snap-bounds="sliderTicksSnapBounds"
                        :data-slider-ticks-labels="sliderTicksLabels"
                        :data-ticks_positions="sliderTicksPositions">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6"><h5>Minuto Móvel</h5></div>
                    <div class="col-lg-6"><h5>Minuto Fixo</h5></div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6"><h2>R$ {{ mobilePrice }}</h2></div>
                    <div class="col-sm-6"><h2>R$ {{ fixedlinePrice }}</h2></div>
                  </div>
                </div>
                <div>
                  <h5 v-if="automaticRechargeAmount >= 500">
                    Com esse desconto a cada <b>1000 minutos</b> você economizará em média <b>R$ {{ averageSaving }},00</b>
                  </h5>
                </div>
              </div>
              <div>
                <div class="form-group">
                  <h5>Informe os <b>dados do cartão de crédito</b> que deseja utilizar</h5>
                </div>
                <div class="form-group">
                  <div
                    class="input-group automaticRechargeCardHolderName"
                    title="Nome impresso no Cartão de Crédito"
                    data-toggle="tooltip"
                    data-placement="top">
                    <div class="input-group-prepend">
                      <i class="input-group-text ik ik-user" />
                    </div>
                    <input
                      type="text"
                      ref="userCardHolderName"
                      class="form-control"
                      id="userCardHolderName"
                      placeholder="Nome no Cartão de Crédito"
                      v-model="userCardHolderName"
                      required>
                  </div>
                </div>
                <div class="form-group">
                  <div
                    class="input-group automaticRechargeCardNumber"
                    title="Número do Cartão de Crédito"
                    data-toggle="tooltip"
                    data-placement="top">
                    <div class="input-group-prepend">
                      <i class="input-group-text ik ik-credit-card" />
                    </div>
                    <input
                      type="text"
                      ref="userCardNumber"
                      class="form-control"
                      id="userCardNumber"
                      placeholder="Número do Cartão de Crédito"
                      :maxlength="userCardNumberLength"
                      v-model="userCardNumber"
                      @input="sanitizeCardNumber"
                      @paste="handlePaste"
                      required>
                  </div>
                </div>
                <div class="form-group">
                  <div
                    class="input-group automaticRechargeCardBrand"
                    title="Bandeira do Cartão de Crédito"
                    data-toggle="tooltip"
                    data-placement="top">
                    <div class="input-group-prepend">
                      <i class="input-group-text ik ik-flag" />
                    </div>
                    <input
                      type="text"
                      ref="userCardBrand"
                      class="form-control"
                      id="userCardBrand"
                      placeholder="Bandeira do Cartão de Crédito"
                      v-model="userCardBrand"
                      readonly
                      required>
                  </div>
                </div>
                <div class="form-group">
                  <div class="d-flex">
                    <div
                      class="input-group"
                      title="Mês de Expiração"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-calendar" />
                      </div>
                      <select
                        class="form-control"
                        v-model="userCardExpiryMonth"
                        required>
                        <option
                          value=""
                          disabled>Mês de Expiração (MM)</option>
                        <option
                          v-for="month in 12"
                          :value="month"
                          :key="month">{{ ('0' + month).slice(-2) }}</option>
                      </select>
                    </div>
                    <div
                      class="input-group mx-2"
                      title="Ano de Expiração"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-calendar" />
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Ano de Expiração (YYYY)"
                        v-model="userCardExpiryYear"
                        maxlength="4"
                        required>
                    </div>
                    <div
                      class="input-group"
                      title="Código de Segurança"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-shield" />
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Código de Segurança"
                        v-model="userCardSecurityCode"
                        :maxlength="userCardSecurityCodeLength"
                        required>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <hr>
            <div>
              <span>Após a compensação, seus créditos serão adicionados automaticamente.</span><br>
              <span>Os pagamentos realizados com cartão de crédito têm a compensação quase sempre instantânea.</span><br>
              <span>Não salvamos os dados sensíveis do seu cartão de crédito.</span>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="closeAutomaticRechargeModal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="(error && error.message) ||
                (!userCardHolderName || !userCardNumber || !userCardExpiryMonth || !userCardExpiryYear || !userCardSecurityCode)"
                @click.prevent="generateAutomaticRecharge">Gerar recarga automática</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'
import { getClientIp } from '@/utils/network'
import DatepickerLanguages from '../Report/datepickerLanguages'
const cardValidator = require('card-validator')
const ACCEPTED_CARD_ASAAS = ['Visa', 'Mastercard', 'Elo', 'Discover', 'American Express', 'Hipercard']
const MOBILE_PRICES = ['0,35', '0,33', '0,30', '0,25', '0,19', '0,12']
const MOBILE_AVERAGE_SAVINGS = [0, 18, 53, 105, 158, 228]
const FIXEDLINE_PRICES = ['0,08', '0,079', '0,078', '0,076', '0,074', '0,07']
const FIXEDLINE_AVERAGE_SAVINGS = [0, 1, 2, 4, 6, 10]
const CHARGE_AMOUNTS = [200, 500, 1000, 2000, 3000, 5000]
const CHARGE_AMOUNT_TIERS = [0, 5, 15, 30, 45, 65]
const CHARGE_AMOUNT_POSITIONS = [0, 20, 40, 60, 80, 100]

export default {
  name: 'AutomaticRechargeNew',
  data () {
    return {
      sliderTicks: CHARGE_AMOUNT_POSITIONS,
      sliderTicksPositions: CHARGE_AMOUNT_POSITIONS,
      sliderTicksLabels: CHARGE_AMOUNT_TIERS.map(v => `${v}%`),
      sliderTicksSnapBounds: 20,
      error: null,
      automaticRechargeMinimumAmount: 20,
      automaticRechargeAmount: 200,
      userCardHolderName: null,
      userCardNumber: null,
      userCardNumberLength: 16,
      userCardExpiryMonth: null,
      userCardExpiryYear: null,
      userCardSecurityCode: null,
      userCardSecurityCodeLength: '3',
      userCardBrand: null,
      clientIp: null
    }
  },
  mounted () {
    getClientIp().then(ip => {
      this.clientIp = ip
    }).catch(() => {
      this.clientIp = null
    })
    this.$nextTick(() => {
      $.fn.datepicker.dates['pt-BR'] = DatepickerLanguages['pt-BR']
      const functionToChangeDateEvent = this.changeDateEvent
      $('.input-daterange input').each(function () {
        $(this).datepicker({
          language: 'pt-BR',
          container: '#picker-container',
          autoclose: true,
          todayHighlight: true
        }).on('changeDate', functionToChangeDateEvent)
      })
      this.buildSlider()
    })
  },
  methods: {
    getAmountByPosition (position) {
      return CHARGE_AMOUNTS[CHARGE_AMOUNT_POSITIONS.findIndex(v => parseInt(v) === parseInt(position))]
    },
    getPositionByAmount (amount) {
      const positionIndex = CHARGE_AMOUNTS.reduce((findIndex, tier, index) => {
        if (parseInt(amount) >= parseInt(tier)) {
          findIndex = index
        }
        return findIndex
      }, 0)
      return positionIndex
    },
    getAmountPositionByAmount (amount) {
      return CHARGE_AMOUNT_POSITIONS[this.getPositionByAmount(amount)]
    },
    buildSlider () {
      $(`#automaticRechargeSlider`).slider({
        value: this.getAmountPositionByAmount(this.automaticRechargeAmount),
        ticks: this.sliderTicks,
        ticks_positions: this.sliderTicksPositions,
        ticks_labels: this.sliderTicksLabels,
        ticks_snap_bounds: this.sliderTicksSnapBounds
      }).on('slide', (slideEvt) => {
        this.automaticRechargeAmount = this.getAmountByPosition(slideEvt.value)
      })
    },
    sliderClick () {
      this.automaticRechargeAmount = this.getAmountByPosition($(`#automaticRechargeSlider`)[0].value)
    },
    resetCharge () {
      this.error = null
      this.automaticRechargeMinimumAmount = 20
      this.automaticRechargeAmount = 100
      this.userCardHolderName = null
      this.userCardNumber = null
      this.userCardNumberLength = 16
      this.userCardExpiryMonth = null
      this.userCardExpiryYear = null
      this.userCardSecurityCode = null
      this.userCardSecurityCodeLength = '3'
      this.userCardBrand = null
    },
    generateAutomaticRecharge (event) {
      event.target.disabled = true
      setTimeout(() => { event.target.disabled = false }, 5000)
      this.error = null

      let payloadRecharge = {
        rechargeAmount: this.automaticRechargeAmount,
        minimumAmount: this.automaticRechargeMinimumAmount,
        cardHolderName: this.userCardHolderName,
        cardNumber: this.userCardNumber,
        cardExpiryMonth: this.userCardExpiryMonth,
        cardExpiryYear: this.userCardExpiryYear,
        cardSecurityCode: this.userCardSecurityCode,
        remoteIp: this.clientIp
      }

      loopback.post('/automatic-recharges', payloadRecharge).then(() => {
        EventBus.$emit('reload-automatic-recharge')
        EventBus.$emit('automatic-recharge-success')
        this.closeAutomaticRechargeModal()
      }).catch(err => {
        if (err.message === 'error to generate credit card token') {
          this.error = {
            message: `Ocorreu um erro: 'Transação não autorizada. Verifique os dados do cartão de crédito e tente novamente.'`
          }
        } else {
          const errorMessages = err.message.split(';')
          if (!errorMessages) {
            this.error = {
              message: [
                'Infelizmente tivemos um problema ao gerar sua recarga automática,',
                '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>'
              ].join(' ')
            }
          }
          if (errorMessages.length > 1) {
            this.error = {
              message: errorMessages.join('<br>')
            }
          } else {
            this.error = {
              message: err.message
            }
          }
        }
        this.userCardFocus()
      })
    },
    userCardFocus () {
      this.$refs.userCardNumber.focus()
    },
    openAutomaticRechargeModal () {
      $(this.$refs.automaticRechargeRequest).modal('show')
    },
    closeAutomaticRechargeModal () {
      this.resetCharge()
      $(this.$refs.automaticRechargeRequest).modal('hide')
    },
    sanitizeCardNumber () {
      this.userCardNumber = this.userCardNumber.replace(/[^0-9]/g, '')
    },
    handlePaste (event) {
      const pastedData = event.clipboardData.getData('Text')
      event.preventDefault()
      this.userCardNumber = pastedData.replace(/[^0-9]/g, '')
    }
  },
  computed: {
    mobilePrice () {
      return MOBILE_PRICES[this.getPositionByAmount(this.automaticRechargeAmount)]
    },
    fixedlinePrice  () {
      return FIXEDLINE_PRICES[this.getPositionByAmount(this.automaticRechargeAmount)]
    },
    averageSaving () {
      return MOBILE_AVERAGE_SAVINGS[this.getPositionByAmount(this.automaticRechargeAmount)] + FIXEDLINE_AVERAGE_SAVINGS[this.getPositionByAmount(this.automaticRechargeAmount)]
    }
  },
  watch: {
    userCardExpiryYear () {
      if (this.userCardExpiryYear && this.userCardExpiryYear.length === 4) {
        const currentYear = new Date().getFullYear()
        const year = Number(this.userCardExpiryYear, 10)
        if (isNaN(year) || year < currentYear) {
          this.error = {
            message: 'É necessário informar um ano de expiração válido.'
          }
        } else {
          this.error = null
        }
      } else {
        this.error = null
      }

      if (this.userCardExpiryMonth && this.userCardExpiryYear && this.userCardExpiryYear.length === 4) {
        const expirationValidation = cardValidator.expirationDate(`${this.userCardExpiryMonth}/${this.userCardExpiryYear}`)
        if (expirationValidation.isValid) {
          this.error = null
        } else {
          this.error = {
            message: 'É necessário informar uma data de expiração válida com mês e ano atual ou futuro. Por favor, verifique os campos e tente novamente.'
          }
        }
      }
    },
    userCardExpiryMonth () {
      if (this.userCardExpiryMonth && this.userCardExpiryYear && this.userCardExpiryYear.length === 4) {
        const expirationValidation = cardValidator.expirationDate(`${this.userCardExpiryMonth}/${this.userCardExpiryYear}`)
        if (expirationValidation.isValid) {
          this.error = null
        } else {
          this.error = {
            message: 'É necessário informar uma data de expiração válida com mês e ano atual ou futuro. Por favor, verifique os campos e tente novamente.'
          }
        }
      }
    },
    userCardNumber () {
      const cardNumberValidation = cardValidator.number(this.userCardNumber)
      if (this.userCardNumber && cardNumberValidation.isPotentiallyValid) {
        if (cardNumberValidation.card) {
          this.error = null
          if (ACCEPTED_CARD_ASAAS.includes(cardNumberValidation.card.niceType)) {
            this.error = null
            this.userCardBrand = cardNumberValidation.card.niceType
          } else {
            this.userCardBrand = null
            this.error = {
              message: 'Esta bandeira não é aceita pelo Asaas.'
            }
          }
          this.userCardSecurityCodeLength = this.userCardBrand === 'American Express' ? '4' : '3'
          this.userCardNumberLength = this.userCardBrand === 'American Express' ? '15' : '16'
          if (this.userCardSecurityCode) this.userCardSecurityCode = this.userCardBrand !== 'American Express' && this.userCardSecurityCode.length === 4 ? '' : this.userCardSecurityCode
        } else {
          this.userCardBrand = null
          this.error = {
            message: 'É necessário informar um número de cartão válido.'
          }
        }
      } else {
        this.userCardBrand = null
        this.error = {
          message: 'É necessário informar um número de cartão válido.'
        }
      }

      if ((this.userCardNumber && this.userCardNumber.length === this.userCardNumberLength)) {
        if (cardNumberValidation.isValid) {
          this.error = null
          this.userCardBrand = cardNumberValidation.card.niceType
        } else {
          this.userCardBrand = null
          this.error = {
            message: 'É necessário informar um número de cartão válido.'
          }
        }
      }
    },
    userCardSecurityCode () {
      const securityCodeValidation = cardValidator.cvv(this.userCardSecurityCode, this.userCardSecurityCodeLength)
      if (this.userCardSecurityCode && !securityCodeValidation.isValid) {
        this.error = {
          message: 'É necessário informar o número do código de segurança válido.'
        }
      } else {
        this.error = null
      }
    },
    automaticRechargeAmount (amount) {
      $(`#automaticRechargeSlider`).slider('setValue', this.getAmountPositionByAmount(amount))
    }
  }
}
</script>

<style lang="scss">
.buttons {
  margin: auto;
  text-align: center;
}
.automaticRechargeAmount {
  text-align: center;
}
.automaticRechargeAmount .input-group {
  max-width: 250px;
  margin: auto;
}
.automaticRechargeAmount .input-group {
  input {
    text-align: right;
    height: 35px;
    font-size: large;
  }
  .input-group-prepend label {
    height: 35px;
    font-size: large;
  }
  .input-group-append label {
    height: 35px;
    font-size: large;
  }
}

.slider.slider-horizontal {
  width: 90% !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AutomaticRecharge/New.vue